import queryString from "query-string";
import styled from "styled-components/macro";

const Container = styled.div`
    box-shadow: 0 1px 6px 0 rgb(0 0 0 / 20%);
    padding: 32px;
    border-radius: 8px;
    width: 80vw;
    max-width: 600px;
    > .logo {
        width: 100%;
        margin-bottom: 20px;
        > .c-logo {
            width: 100%;
            height: 50px;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
        }
    }
    > .title {
        font-size: 1.5rem;
    }
    > .text {
    }
    > .buttons {
        margin-top: 1rem;
    }
`;

function Component(props) {
    function updateInvoiceSettings() {
        const params = queryString.parse(props.location.search);
        const { code, state } = params;

        window.opener.postMessage(
            {
                type: "INVOICE_AUTH_CODE",
                authCode: code,
                returnState: state,
            },
            window.location.origin,
        );
        window.close();
    }

    return (
        <Container>
            <div className="logo">
                <div className="c-logo"></div>
            </div>
            <div className="title">Fortnox</div>
            <div className="text">
                Genom att koppla till Fortnox kan ni hantera fakturor.
            </div>
            <div className="buttons">
                <button
                    className="c-button c-button--raised"
                    onClick={() => {
                        updateInvoiceSettings();
                    }}
                >
                    Aktivera fakturahantering
                </button>
            </div>
        </Container>
    );
}

export default Component;
